import { string, object, SchemaOf } from 'yup'

export interface IAuthEmailSchema {
    email: string
}

const requestEmailSchema: SchemaOf<IAuthEmailSchema> = object().shape({
    email: string().email('E-mail inválido.').required('Preencha o campo com seu e-mail.'),
})

export default requestEmailSchema
